module.exports = __webpack_public_path__ + "img/rep_all.3d276305.png";